import { createActions, handleActions } from 'redux-actions';

const initState = {
  summaryData: [],
  detailData: {},

  fetching: false,
  error: null,
};

export const creators = createActions({
  YEARLYYTD_SUMMARY_REQUEST: (selectedYears) => ({
    selectedYears,
  }),
  YEARLYYTD_DETAIL_REQUEST: (
    selectedYears,
    defaultYear,
    defaultMonth,
    DateKey,
  ) => ({
    selectedYears,
    defaultYear,
    defaultMonth,
    DateKey,
  }),
  YEARLYYTD_SUCCESS: (payload) => payload,
  YEARLYYTD_FAILURE: (payload) => payload,
});

const summaryReducer = (state) => {
  return { ...state, fetching: true, error: null };
};

const detailReducer = (state) => {
  return { ...state, fetching: true, error: null };
};

const successReducer = (state, { payload }) => {
  const nextState = Object.assign({}, state, payload);
  nextState.fetching = false;
  return nextState;
};

const failureReducer = (state, { payload }) => {
  return { ...state, fetching: false, error: payload };
};

export default handleActions(
  {
    YEARLYYTD_SUMMARY_REQUEST: summaryReducer,
    YEARLYYTD_DETAIL_REQUEST: detailReducer,
    YEARLYYTD_SUCCESS: successReducer,
    YEARLYYTD_FAILURE: failureReducer,
  },
  initState,
);
